import PropTypes from "prop-types";
import { getUnit } from "./Units";

const UnitText = props => {
	return getUnit(props.units[props.unit]).genUnit();
};

UnitText.propTypes = {
	unit: PropTypes.string.isRequired,
	units: PropTypes.object.isRequired
};

export default UnitText;
